// @flow

export const OLYMPIAD_IDS = {
  math: {
    '1': '1101',
    '2': '1101',
    '3': '1102',
    '4': '1102',
    '5': '1107',
    '6': '1107',
    '7': '1108',
    '8': '1108',
    '9': '1113',
    '10': '1114',
    '11': '1114',
  },
  eng: {
    '1': '1103',
    '2': '1103',
    '3': '1104',
    '4': '1104',
    '5': '1109',
    '6': '1109',
    '7': '1110',
    '8': '1110',
    '9': '1115',
    '10': '1116',
    '11': '1116',
  },
  russian: {
    '1': '1105',
    '2': '1105',
    '3': '1106',
    '4': '1106',
    '5': '1111',
    '6': '1111',
    '7': '1112',
    '8': '1112',
    '9': '1117',
    '10': '1118',
    '11': '1118',
  },
  it: { '9': '1119', '10': '1120', '11': '1120' },
}

export const TAGS = {
  math: {
    id: 1233,
    value: 'math-olymp.foxford.ru | visited',
  },
  eng: {
    id: 1231,
    value: 'eng-olymp.foxford.ru | visited',
  },
  it: {
    id: 1229,
    value: 'it-olymp.foxford.ru | visited',
  },
  russian: {
    id: 1227,
    value: 'russian-olymp.foxford.ru | visited',
  },
}
